export default function getHeaders(contexto) {
    return {
        'Authorization': `Bearer ${contexto.$store.state.usuario.token}`,
        // 'Content-Type': 'application/json'  // Asegura que se envía JSON
    }
}